
document.addEventListener('DOMContentLoaded', function () {
  // ARCANUM transition removed — intro handled by arcanum layout
});
